/* MUI */
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

/*  Shared  */
import { DarkTooltip } from 'application/Shared/Components/Tooltips';
import { FontSizes } from 'application/Shared/Constants';
import { Helpers } from 'application/Shared/Helpers';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Sparklines, SparklinesBars, SparklinesLine } from 'react-sparklines';

/*  Components  */
import { HMS } from './HMS';

const Chart = ({ usageChart, max, sx }) => {
    const theme = useTheme();

    return (
        <div>
            <Sparklines
                max={max}
                data={Helpers.padArray(usageChart, 20, 0)}
                style={{ width: '100%', ...sx }}
            >
                <SparklinesBars
                    style={{
                        fill: theme.palette.sparkLines.sparkBar,
                        stroke: theme.palette.sparkLines.stroke
                    }}
                />
                <SparklinesLine
                    color={theme.palette.sparkLines.sparkLine}
                    style={{ fill: 'none' }}
                />
            </Sparklines>
        </div>
    );
};

export const Usage = (props) => {
    const { chartOnly, max, sx, usage, usageChart } = props;
    const { t } = useTranslation();

    if (!usageChart) {
        return null;
    }

    if (chartOnly) {
        return <Chart usageChart={usageChart} max={max} sx={sx} />;
    }

    if (!usage) {
        return null;
    }

    return (
        <DarkTooltip
            arrow
            title={
                <>
                    <HMS
                        seconds={usage}
                        includeDays
                        includeText
                        sx={{ fontSize: FontSizes[0] }}
                    />
                    {t('Common.usage_over_90')}
                </>
            }
        >
            <Box>
                <Chart usageChart={usageChart} max={max} sx={sx} />
            </Box>
        </DarkTooltip>
    );
};
